module.exports = __webpack_public_path__ + "img/golden-planet.258c7396.svg";